import { Component, Prop, Vue } from 'vue-property-decorator';
import { Menu } from './types/menu';
import { MenuItem } from './types/menu-item';
import { ApplicationConfigService } from '../../../modules/services/application-config/application-config.service';
import { AuthenticationService } from '../../../modules/authentication/services/authentication.service';
import { RouterPath } from '../../enums/router-path.enum';
import { StringUtil } from '../../util/string/string.util';
import { namespace } from 'vuex-class';
import { ActiveWorkspaceState } from '../../../store/auth/types';
import { Role } from '../../enums/role.enum';
import amplitude from 'amplitude-js';

const uiModule = namespace('ui');
const authModule = namespace('auth');

interface UI {
    showRouteDropdown: boolean;
    userPermissions: any;
    sidebarPosition: any;
    status: {
        sidebarExpand: boolean;
    };
    menuOpened: string;
    menuFilter: string;
    menus: Array<Menu>;
    paths: object;
}

@Component({
    template: require('./bs-sidebar.html'),
})
export default class BSSidebarComponent extends Vue {

    @authModule.Getter('roles') userRoles: Array<string>;
    @authModule.Getter('workspaces') workspaces: Array<String>;
    @authModule.Getter('activeWorkspace') activeWorkspace: ActiveWorkspaceState;
    @authModule.Getter('isB2B') isB2B: boolean;
    // @uiModule.Mutation('sidebarExpanded') sidebarExpanded;
    private amplitudeProject = amplitude.getInstance();

    ui: UI = {
        showRouteDropdown: false,
        userPermissions: {},
        sidebarPosition: null,
        status: {
            sidebarExpand: false,
        },
        menuOpened: '',
        menuFilter: '',
        menus: [],
        paths: { HOME: RouterPath.ROOT},
    };

    @Prop(Boolean)
    sidebarCompressed: boolean;

    created() {
        this.initializeMenu();
    }

    mounted() {
        setTimeout(() => {
            this.initializeMenu();
            this.ui.menus.forEach(menu => {
                if (menu.menuItems && menu.menuItems.length) {
                    if (this.hasAtLeastOnePermission(menu.menuItems) && menu.group) {
                        const elements = this.$refs[menu.group] as any[];
                        if (elements && elements.length) {
                            this.adjustSubmenuPosition((elements[0] as HTMLElement));
                        }
                    }
                }
            });
        }, 1000);
    }

    initializeMenu() {
        this.ui.menus = [
            {
                group: 'Vendas',
                name: 'Vendas',
                icon: 'insert_chart_outlined',
                new: false,
                menuItems: [
                    { to: RouterPath.DASHBOARD, name: 'Evolução de vendas', hasPermission: this.hasDashboard(), } as MenuItem,
                ]
            },
            {
                group: 'Financeiro',
                name: 'Financeiro',
                // icon: 'attach_money',
                image: {
                    active: '../../../assets/img/extrato.svg',
                    inactive: '../../../assets/img/extrato.svg'
                },
                new: false,
                menuItems: [
                    { to: this.urlAccount(), name: 'Faturas e Notas', hasPermission: this.hasInvoice(), isExternalLink: true } as MenuItem,
                    { to: RouterPath.PAGE_EXTRACT, name: 'Extrato', hasPermission: this.hasInvoice(), } as MenuItem,
                ]
            },
            {
                group: 'Permissões',
                name: 'Permissões',
                icon: 'group',
                new: false,
                menuItems: [
                    { to: RouterPath.PAGE_USERS, name: 'Colaboradores', hasPermission: this.hasPermissions() } as MenuItem,
                ]
            },
            {
                group: 'Buson Suíte',
                name: 'Administrativo',
                image: {
                    active: '../../../assets/img/inventario.svg',
                    inactive: '../../../assets/img/inventario.svg'
                },
                new: false,
                menuItems: [
                {
                    to: this.redirectToGpass(),
                    isExternalLink: true,
                    name: 'Administrativo',
                    hasPermission: true,
                } as MenuItem,
                ]
            },
            // {
            //     group: 'Guichê Pago',
            //     name: 'Guichê Pago',
            //     icon: 'account_balance',
            //     new: true,
            //     menuItems: [
            //     {
            //         to: this.hasFitBankAccount() ? `${process.env.VUE_APP_GUICHE_PAGO_ACCESS}` : `${process.env.VUE_APP_GUICHE_PAGO_OPEN}`,
            //         isExternalLink: true,
            //         name: this.hasFitBankAccount() ? 'Acessar conta' : 'Abrir Conta',
            //         hasPermission: true,
            //     } as MenuItem,
            //     ]
            // },
        ];
    }

    async logout() {
        AuthenticationService.logout(ApplicationConfigService.urlSuite);
    }

    get menus() {
        if (!this.ui.menuFilter)
        return this.ui.menus;

        const filter = StringUtil.normalize(this.ui.menuFilter.toLowerCase());

        return this.ui.menus.reduce((list: Menu[], menu) => {
        console.log(list);
        const filteredInner = menu.menuItems.filter(item =>
            StringUtil.normalize(item.name.toLowerCase()).includes(filter)
        );

        if (filteredInner.length < 1 && !menu.name.toLowerCase().includes(filter))
            return list;

        const tempMenu: Menu = {
            name: menu.name,
            group: menu.group,
            icon: menu.icon,
            menuItems: filteredInner.length ? filteredInner : menu.menuItems
        };

        list.push(tempMenu);
        return list;
        }, []);
    }

    hasAtLeastOnePermission(sidebarItem: Array<any>) {
        return sidebarItem.some(item => item.hasPermission);
    }

    subIsActive(menuItems: Array<MenuItem>) {
        return menuItems.some(menu => !!menu.to && this.$route.path.indexOf(menu.to) === 0); // current path starts with this path string
    }

    // close() {
    //     this.sidebarExpanded(true);
    // }

    middleware(event): boolean {
        return event.target.className !== 'navbar-toggler';
    }

    toggleExpand() {
        this.ui.menuOpened = '';
        this.$emit('on-toggle-action-expand', !this.sidebarCompressed);
        this.logAmplitudeSidebarExpand();
    }

    onClickOutside() {
        // this.ui.status.sidebarExpand = false;
        this.ui.menuFilter = '';
        this.$emit('on-toggle-action-expand', false);
    }

    isMenuOpen(menu: string) {
        // Se existe um filtro aplicado, ele exibe os menus abertos
        if (this.ui.menuFilter) {
        return true;
        }

        return this.ui.menuOpened === menu;
    }

    setSubmenuClass(menuItems?: Array<MenuItem>) {
        if (menuItems === undefined || menuItems === null) {
        return '';
        }
        return this.subIsActive(menuItems) ? 'smi-active' : '';
    }

    expandSubmenu(menu: string) {
        if (!this.isSidebarExpand) return;

        if (this.ui.menuOpened && this.ui.menuOpened === menu) {
        this.ui.menuOpened = '';
        return;
        }

        this.ui.menuOpened = menu;
    }

    getMenuImageImage(menu: any) {
        if (this.subIsActive(menu.menuItems)) {
        return menu.image.active;
        }
        return menu.image.inactive;
    }

    getMenuName(menuName: string) {
        return `${menuName} <i class="material-icons smi-icon">keyboard_arrow_down</i>`;
    }

    redirectToGpass() {
        return `${ApplicationConfigService.urlGpassAdmin}/#/inicio`;
    }

    adjustSubmenuPosition(submenu: HTMLElement) {
        if (typeof window === 'undefined') return;

        const submenuPosition = submenu.getBoundingClientRect();
        const spaceBelow = window.innerHeight - submenuPosition.top;

        // Desloca o submenu para cima de acordo com o tamnho que ficou fora da tela (com um espaço extra de 16px)
        if (spaceBelow < submenu.offsetHeight) {
        submenu.style.top = `-${submenu.offsetHeight - spaceBelow + 20}px`;
        return;
        }

        submenu.style.top = submenu.getBoundingClientRect().top.toString();
    }

    get sidebarClass() {
        return this.sidebarCompressed ? 'sidebar-expanded' : 'sidebar-compressed';
    }

    get setSidebarClass() {
        if (this.sidebarCompressed) {
            return 'sidebar-expanded';
        }
        return 'sidebar-compressed';
    }

    get isSidebarExpand() {
        return this.sidebarCompressed;
    }

    onMouseOver() {
        this.$emit('on-sidebar-hover', true);
    }

    onMouseLeave() {
        this.$emit('on-sidebar-hover', false);
    }

    hasRole(role: Role): boolean {
        return this.userRoles && this.userRoles.some(userRole => userRole === role);
    }

    hasB2B(): boolean {
        // return this.group && this.group.attributes && this.group.attributes.sales_channel.indexOf('B2B') > -1;
        return this.isB2B;
    }

    hasFitBankAccount() {
        return ApplicationConfigService.hasFitBankAccount();
    }

    hasPermissions() {
        return this.hasRole(Role.PERMISSION) && !this.hasB2B();
    }

    hasInvoice() {
        return this.hasRole(Role.INVOICE);
    }

    hasDashboard() {
        return this.hasRole(Role.DASHBOARD);
    }

    /********************************************************************
    AMPLITUDE - EVENTOS DO GRUPO SIDEBAR
  *********************************************************************/
  // Mapear rotas clicadas pela sidebar
    logAmplitudeSidebarRoutes(route: string) {
        try {
        this.amplitudeProject.logEvent('sidebar_page_selected', {
            page: route,
        });
        } catch (error) {
            console.error('Amplitude event error: sidebar_page_selected');
        }
    }

    // Mapear expandir/comprimir sidebar
    logAmplitudeSidebarExpand() {
        try {
            this.amplitudeProject.logEvent('sidebar_expand_toggle', {
            status: this.sidebarCompressed ? 'opened' : 'closed',
        });
        } catch (error) {
            console.error('Amplitude event error: sidebar_expand_toggle');
        }
    }

    // Mapear expansão de um grupo da sidebar
    logAmplitudeSubmenuExpand() {
        try {
            this.amplitudeProject.logEvent('sidebar_group_expanded', {
                group: this.ui.menuOpened,
            });
        } catch (error) {
            console.error('Amplitude event error: sidebar_group_expanded');
        }
    }

    urlAccount() {
        if (ApplicationConfigService.urlSuite === '') {
            setTimeout(() => {
                if (ApplicationConfigService.urlSuite !== '')
                    this.initializeMenu();
                else
                    this.urlAccount();
            }, 500);
        }
        return ApplicationConfigService.urlSuite + '/minha-conta?marketplace=true';
    }
}
